<template>
    <div>
      <div id="time_chart"></div>
      <div class="time_info2">
        <span>09:30</span>
        <span>11:30/13:00</span>
        <span>15:00</span>
      </div>
      <div id="volume_chart"></div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts'
  
  export default {
    props: {
        timeData: {
            type: Object,
            required: true
        },
        stock_data:{
            type: Object,
        },
        code: {           // 👈 新增：股票代码
            type: String,
            required: true
        },
        autoRefresh: {    // 👈 新增：刷新开关
            type: Boolean,
            default: true
        },
        refreshInterval: { // 👈 新增：刷新间隔
            type: Number,
            default: 60000
        }
    },
    data() {
        return {
            refreshTimer: null,
            chart1: null,
            chart2: null,
            _resizeHandler: null   // 👈 新增：用于存储 resize 事件处理函数

        }
    },
    computed: {
        // 判断当前是否在交易时间内
        isTradingTime() {
            const now = new Date()
            const hours = now.getHours()
            const minutes = now.getMinutes()
            const totalMinutes = hours * 60 + minutes
            
            // 上午：9:30 - 11:30 (570 - 690)
            const morningStart = 9 * 60 + 30   // 570
            const morningEnd = 11 * 60 + 30    // 690
            // 下午：13:00 - 15:00 (780 - 900)
            const afternoonStart = 13 * 60     // 780
            const afternoonEnd = 15 * 60       // 900
            
            return (totalMinutes >= morningStart && totalMinutes <= morningEnd) ||
                (totalMinutes >= afternoonStart && totalMinutes <= afternoonEnd)
        }
    },
    mounted() {
        this.drawChart()
        // 只有交易时间才启动自动刷新
        if (this.autoRefresh && this.isTradingTime) {
            this.startAutoRefresh()
        }
    },
    beforeDestroy() {
        this.stopAutoRefresh()
        if (this.chart1) {
            this.chart1.dispose()
            this.chart1 = null
        }
        if (this.chart2) {
            this.chart2.dispose()
            this.chart2 = null
        }
    },
    watch: {
        timeData: {
            handler() { this.drawChart() },
            deep: true
        },
        // 👈 新增：监听刷新开关
        autoRefresh: {
            handler(val) {
            if (val && this.isTradingTime) {
                this.startAutoRefresh()
            } else {
                this.stopAutoRefresh()
            }
            }
        },
        // 👈 新增：监听交易时间变化（跨时间段时自动切换）
        isTradingTime: {
            handler(val) {
            if (val && this.autoRefresh) {
                this.startAutoRefresh()
            } else {
                this.stopAutoRefresh()
            }
            },
            immediate: true
        }
    },
    methods: {
        // 👈 新增：启动定时刷新
        startAutoRefresh() {
            // 先清除旧定时器
            if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
            this.refreshTimer = null
            }
            // 再次检查是否在交易时间
            if (!this.isTradingTime) return
            
            this.refreshTimer = setInterval(() => {
            // 通知父组件刷新数据
            this.$emit('refresh')
            }, this.refreshInterval)
        },
        
        // 👈 新增：停止定时刷新
        stopAutoRefresh() {
            if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
            this.refreshTimer = null
            }
        },

      fontSize(res) {
        const docEl = document.documentElement
        const clientWidth = window.innerWidth || docEl.clientWidth || document.body.clientWidth
        if (!clientWidth) return res
        return res * (clientWidth / 750)
      },
      drawChart() {
  const data = this.timeData;
  console.log('stock_data',this.stock_data);
  const timestamps = Object.keys(data).sort((a, b) => Number(a) - Number(b))
  if (timestamps.length === 0) return

  // ---------- 1. 提取数据（顺序） ----------
  const jsonArr = timestamps.map(ts => data[ts])
  const avg = jsonArr.map(item => parseFloat(item.a))
  const price = jsonArr.map(item => parseFloat(item.p))
  const volume = jsonArr.map(item => parseFloat(item.v))
  // 成交量颜色（与前一笔比较）
  const color = price.map((p, i) => {
    if (i === 0) return 'red'
    return p < price[i - 1] ? 'green' : 'red'
  })

  // ========== 计算 Y 轴范围 ==========
  // 获取昨收价（不使用 ?. 可选链）
  const yClose = parseFloat(this.stock_data && this.stock_data.y_close) || price[0];
  
  // 获取今日最高/最低（从 stock_data 中取）
  const high = parseFloat(this.stock_data && this.stock_data.high) || Math.max.apply(null, price.filter(function(p) { return !isNaN(p) }))
  const low = parseFloat(this.stock_data && this.stock_data.low) || Math.min.apply(null, price.filter(function(p) { return !isNaN(p) }))
  
  // 计算最高/最低相对于昨收的偏离值
  var diffHigh = Math.abs(high - yClose)
  var diffLow = Math.abs(yClose - low)
  
  // 取最大偏离值，并至少保留 0.5 的幅度
  var abs = Math.max(diffHigh, diffLow, 0.5)
  
  // 计算 Y 轴上下限（以昨收为中心对称）
  var yMax = Number((yClose + abs).toFixed(2))
  var yMin = Number((yClose - abs).toFixed(2))
  
  console.log('Y轴范围:', yMin, '~', yMax, '基准:', yClose)

  // ---------- 2. 固定 X 轴数据 ----------
  var xData = [
    "09:30","09:31","09:32","09:33","09:34","09:35","09:36","09:37","09:38","09:39",
    "09:40","09:41","09:42","09:43","09:44","09:45","09:46","09:47","09:48","09:49",
    "09:50","09:51","09:52","09:53","09:54","09:55","09:56","09:57","09:58","09:59",
    "10:00","10:01","10:02","10:03","10:04","10:05","10:06","10:07","10:08","10:09",
    "10:10","10:11","10:12","10:13","10:14","10:15","10:16","10:17","10:18","10:19",
    "10:20","10:21","10:22","10:23","10:24","10:25","10:26","10:27","10:28","10:29",
    "10:30","10:31","10:32","10:33","10:34","10:35","10:36","10:37","10:38","10:39",
    "10:40","10:41","10:42","10:43","10:44","10:45","10:46","10:47","10:48","10:49",
    "10:50","10:51","10:52","10:53","10:54","10:55","10:56","10:57","10:58","10:59",
    "11:00","11:01","11:02","11:03","11:04","11:05","11:06","11:07","11:08","11:09",
    "11:10","11:11","11:12","11:13","11:14","11:15","11:16","11:17","11:18","11:19",
    "11:20","11:21","11:22","11:23","11:24","11:25","11:26","11:27","11:28","11:29",
    "11:30/13:00",
    "13:01","13:02","13:03","13:04","13:05","13:06","13:07","13:08","13:09","13:10",
    "13:11","13:12","13:13","13:14","13:15","13:16","13:17","13:18","13:19","13:20",
    "13:21","13:22","13:23","13:24","13:25","13:26","13:27","13:28","13:29","13:30",
    "13:31","13:32","13:33","13:34","13:35","13:36","13:37","13:38","13:39","13:40",
    "13:41","13:42","13:43","13:44","13:45","13:46","13:47","13:48","13:49","13:50",
    "13:51","13:52","13:53","13:54","13:55","13:56","13:57","13:58","13:59",
    "14:00","14:01","14:02","14:03","14:04","14:05","14:06","14:07","14:08","14:09",
    "14:10","14:11","14:12","14:13","14:14","14:15","14:16","14:17","14:18","14:19",
    "14:20","14:21","14:22","14:23","14:24","14:25","14:26","14:27","14:28","14:29",
    "14:30","14:31","14:32","14:33","14:34","14:35","14:36","14:37","14:38","14:39",
    "14:40","14:41","14:42","14:43","14:44","14:45","14:46","14:47","14:48","14:49",
    "14:50","14:51","14:52","14:53","14:54","14:55","14:56","14:57","14:58","14:59",
    "15:00"
  ]

  // ---------- 3. 按顺序填充数据 ----------
  var prices = new Array(241).fill(null)
  var avgs = new Array(241).fill(null)
  var vols = new Array(241).fill(null)
  var volColors = new Array(241).fill('#CCCCCC')

  var len = Math.min(price.length, 241)  // 最多填满241个
  for (var i = 0; i < len; i++) {
    prices[i] = price[i]
    avgs[i] = avg[i]
    vols[i] = volume[i]
    volColors[i] = color[i] === 'red' ? '#FE484A' : '#0AC890'
  }

  console.log('vols',vols)

  // ---------- 4. ECharts 配置 ----------
  var upColor = '#FE484A'
  var downColor = '#0AC890'
  var lineColor = '#448DFE'
  var avgLineColor = '#F0DB4F'

  var option1 = {
    animation:false,
  grid: { left: 25, right: 10, top: 25, bottom: 25 },  // 👈 grid 边距可以调小，因为标签在内部
  xAxis: {
    type: 'category',
    boundaryGap: false,
    axisTick: { interval: 29 },
    axisLabel: { show: false },
    axisLine: { onZero: false, lineStyle: { width: 1, color: '#EBF1FD' } },
    splitLine: { show: true, lineStyle: { width: 1, color: '#EBF1FD' } },
    axisPointer: { type: 'line', lineStyle: { type: 'dashed' }, label: { show: false } },
    data: xData
  },
  yAxis: [
    {
      type: 'value',
      min: yMin,
      max: yMax,
      axisLine: { show: false },
      axisTick: { show: false },
      splitNumber:6,
      //interval:(yMin - yMin) / 6 ,
      splitLine: { 
        show: true, 
        lineStyle: { color: '#E8E8E8', type: 'dashed' } 
      },
      axisLabel: {
        color: '#999999',
        fontSize: this.fontSize(18),
        //margin: -80,
        inside: true,
        // formatter: function(v) {
        //   if (v === yMax || v === yClose || v === yMin) {
        //     return v.toFixed(2)
        //   }
        //   return ''
        // }

        formatter: function(v) {
            // 保留两位小数后再比较
            var vFixed = parseFloat(v.toFixed(2))
            var yMinFixed = parseFloat(yMin.toFixed(2))
            var yCloseFixed = parseFloat(yClose.toFixed(2))
            var yMaxFixed = parseFloat(yMax.toFixed(2))
            
            if (vFixed === yMaxFixed || vFixed === yCloseFixed || vFixed === yMinFixed) {
              console.log('保留两位小数后再比较',v.toFixed(2));
              return v.toFixed(2)
            }
            return ''
          }
        }
    },
    {
      type: 'value',
      min: ((yMin - yClose) / yClose * 100),
      max: ((yMax - yClose) / yClose * 100),
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      splitNumber:6,
      axisLabel: {
        color: '#999999',
        fontSize: this.fontSize(18),
        //margin: -100,
        inside: true,
        formatter: function(v) {
          var pMax = ((yMax - yClose) / yClose * 100)
          var pMin = ((yMin - yClose) / yClose * 100)
          var pClose = 0
          
          var vFixed = parseFloat(v.toFixed(2))
          var pMaxFixed = parseFloat(pMax.toFixed(2))
          var pMinFixed = parseFloat(pMin.toFixed(2))
          var pCloseFixed = parseFloat(pClose.toFixed(2))
          
          if (vFixed === pMaxFixed || vFixed === pCloseFixed || vFixed === pMinFixed) {
            var prefix = v > 0 ? '+' : ''
            return prefix + v.toFixed(2) + '%'
          }
          return ''
        }
      }
    }
  ],
  series: [
    {
      name: '分时线',
      type: 'line',
      data: prices,
      smooth: true,
      connectNulls: true,
      lineStyle: { color: lineColor, width: 2 },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(68,141,254,0.3)' },
            { offset: 1, color: 'rgba(68,141,254,0.05)' }
          ]
        }
      },
      symbol: 'none',
      yAxisIndex: 0
    },
    {
      name: '均价线',
      type: 'line',
      data: avgs,
      smooth: true,
      connectNulls: true,
      lineStyle: { color: avgLineColor, width: 1.5, type: 'solid' },
      symbol: 'none',
      yAxisIndex: 0
    }
  ]
}

  var option2 = {
    animation:false,
    grid: { left: 5, right: 5, top: 5, bottom: 5 },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisTick: { interval: 29 },
      axisLabel: { show: false },
      axisLine: { onZero: false, lineStyle: { width: 1, color: '#EBF1FD' } },
      splitLine: { show: true, lineStyle: { width: 1, color: '#EBF1FD' } },
      axisPointer: { type: 'line', lineStyle: { type: 'dashed' }, label: { show: false } },
      data: xData
    },
    yAxis: {
      scale: true,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: true, lineStyle: { color: '#E8E8E8', type: 'dashed' } },
      axisLabel: {
        color: '#939393',
        fontSize: this.fontSize(18),
        formatter: function(v) { return v >= 10000 ? (v / 10000).toFixed(2) + '万' : v }
      }
    },
    series: [
      {
        name: '成交量',
        type: 'bar',
        data: vols,
        //barMinHeight: 2, 
        itemStyle: {
          color: function(params) { return volColors[params.dataIndex] || '#CCCCCC' }
        },
        barWidth: '60%',
        barGap: '10%'
      }
    ]
  }

  // ---------- 5. 渲染（复用图表实例） ----------
  if (!this.chart1) {
    this.chart1 = echarts.init(document.getElementById('time_chart'))
  }
  if (!this.chart2) {
    this.chart2 = echarts.init(document.getElementById('volume_chart'))
  }
  this.chart1.setOption(option1, true)
  this.chart2.setOption(option2, true)

  // 窗口自适应（只绑定一次）
  if (!this._resizeHandler) {
    this._resizeHandler = function() {
      if (this.chart1) this.chart1.resize()
      if (this.chart2) this.chart2.resize()
    }.bind(this)
    window.addEventListener('resize', this._resizeHandler)
  }
}
    }
  }
  </script>
  
  <style lang="scss">
  .time_info2 {
    font-size: 0.24rem;
    color: #939393;
    position: relative;
    height:16px;
    display: flex;
    align-items: center;
    justify-content: space-between;


  }
  </style>
  